<template>
  <CardBase :apagada="!integracao.ativo">
    <template #logo>
      <LogoIntegracao
        :logo="marca.logo || conector.logo"
        :nome="integracao.provedor_nome"
        :cor="marca.cor"
        :icone="iconeCoreUi"
        :usar-monograma="!!marca.cor"
        tamanho="grande"
      />
    </template>

    <template #selos>
      <ChipStatusIntegracao
        :ativo="integracao.ativo"
        :status-conexao="integracao.status_conexao"
      />
    </template>

    <template #nome>{{ integracao.nome }}</template>
    <template #subtitulo>
      {{ conector.categoria_nome }} · {{ integracao.provedor_nome }}
    </template>

    <div class="card-integracao__linhas">
      <div v-if="integracao.escopo_nome" class="card-integracao__linha">
        <span class="rotulo">Finalidade</span>
        <span class="valor">{{ integracao.escopo_nome }}</span>
      </div>

      <div v-if="integracao.filial_id" class="card-integracao__linha">
        <span class="rotulo">Filial</span>
        <span class="valor">{{ integracao.filial_id }}</span>
      </div>

      <div class="card-integracao__linha">
        <span class="rotulo">Última verificação</span>
        <span class="valor">{{ ultimaVerificacao }}</span>
      </div>
    </div>

    <div v-if="integracao.ativo && integracao.ultimo_erro" class="card-integracao__erro">
      {{ integracao.ultimo_erro }}
    </div>

    <template #rodape>
      <CButton size="sm" color="primary" @click="$emit('configurar', integracao)">
        <fa-icon icon="pencil-alt" /> Configurar
      </CButton>

      <CButton
        v-if="integracao.permite_teste"
        size="sm"
        variant="outline"
        color="info"
        class="acao-testar"
        :disabled="testando"
        @click="$emit('testar', integracao)"
      >
        <fa-icon :icon="testando ? 'spinner' : 'plug'" :spin="testando" />
        {{ testando ? 'Testando' : 'Testar' }}
      </CButton>

      <CButton
        size="sm"
        variant="outline"
        :color="integracao.ativo ? 'secondary' : 'success'"
        @click="$emit('alternar-ativacao', integracao)"
      >
        {{ integracao.ativo ? 'Desativar' : 'Ativar' }}
      </CButton>

      <CButton
        size="sm"
        variant="outline"
        color="danger"
        class="acao-remover"
        title="Remover integração"
        @click="$emit('remover', integracao)"
      >
        <fa-icon icon="trash-alt" />
      </CButton>
    </template>
  </CardBase>
</template>

<script>
import TEXTOS from '@/views/Integracoes/textos';
import CardBase from './CardBase';
import ChipStatusIntegracao from './ChipStatusIntegracao';
import LogoIntegracao from './LogoIntegracao';

export default {
  name: 'CardIntegracao',
  components: { CardBase, ChipStatusIntegracao, LogoIntegracao },
  props: {
    integracao: {
      type: Object,
      required: true,
    },
    // Enquanto o teste de conexão desta instância está em andamento.
    testando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    conector() {
      return this.integracao.conector || {};
    },

    /*
     * Marca do provedor efetivamente configurado — é ela que identifica a
     * instância. Duas configurações do mesmo conector com provedores
     * diferentes (SimFrete e Lincros) precisam se distinguir no card.
     */
    marca() {
      return this.integracao.marca_provedor || {};
    },

    /*
     * O catálogo guarda o ícone já no formato do CoreUI (`cil-phone`), que é o
     * mesmo usado pelo menu lateral. Sem ícone declarado, cai no genérico de
     * "encaixe", que é o que o módulo representa.
     */
    iconeCoreUi() {
      return this.conector.icone || 'cil-puzzle';
    },

    ultimaVerificacao() {
      if (!this.integracao.testado_em) {
        return TEXTOS.NUNCA_TESTADA;
      }

      const data = new Date(this.integracao.testado_em);

      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
/* A moldura vem do CardBase; aqui fica só o que é desta lista. */
.card-integracao__linhas {
  margin-top: 10px;
}

.card-integracao__linha {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
  font-size: 12px;
}

.card-integracao__linha .rotulo {
  color: #667085;
}

.card-integracao__linha .valor {
  color: #344054;
  font-weight: 500;
  text-align: right;
}

.card-integracao__erro {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fdecec;
  color: #a4292b;
  font-size: 12px;
  line-height: 1.4;
}

.acao-remover {
  margin-left: auto;
}

/*
 * Largura reservada para o rótulo mais longo.
 *
 * O texto troca enquanto o teste acontece, e com a largura seguindo o texto o
 * botão crescia, empurrava os vizinhos e acabava quebrando o próprio conteúdo
 * em duas linhas — o rodapé inteiro mudava de altura no meio da ação. Em `ch`
 * porque o que precisa caber é um número de caracteres, não um tamanho em
 * pixels que a fonte pode desmentir.
 */
.acao-testar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  min-width: 12ch;
}
</style>
